import { render, staticRenderFns } from "./ProductStockDisplay.vue?vue&type=template&id=ff5fb678&scoped=true&"
import script from "./ProductStockDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductStockDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockDisplay.vue?vue&type=style&index=0&id=ff5fb678&lang=scss&scoped=true&"
import style1 from "./ProductStockDisplay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5fb678",
  null
  
)

export default component.exports